import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import BubbleLoader from '../../../Libraries/Loader/bubble-loader';
import { useI18n } from '../../utilities/i18n';

export default function Breadcrumbs({ items }) {
    const i18n = useI18n()

    if (!i18n) {
        return <BubbleLoader />
    }

    return <div className="mt-2 overflow-auto">
        <ul className="flex items-center opacity-75 py-2 min-w-min border-b border-grey-300">
            <li className="flex items-center leading-relaxed min-w-min">
                <Link className="text-sm md:hover:underline" to="/">
                    <span dangerouslySetInnerHTML={{ __html: i18n.breadcrumbs.dashboard.replaceAll(' ', '&nbsp;')}} />
                </Link>
            </li>
            { items.map(item => (<Fragment key={item.label}>
                <li className="px-2 min-w-content">
                    <svg width="5" height="6" viewBox="0 0 5 6" xmlns="http://www.w3.org/2000/svg">
                        <g fill="none" fillRule="evenodd">
                            <path d="M-127.5-353.5h3599v3599h-3599z" fill="#FFF" stroke="#8E8E8E"/>
                            <path d="M1.044 6L4 3 1 0" stroke="#333" strokeLinejoin="round"/>
                        </g>
                    </svg>
                </li>
                { item.url ? <li className="flex items-center leading-relaxed min-w-min">
                    <Link className="text-sm md:hover:underline" to={ item.url }>
                        <span dangerouslySetInnerHTML={{ __html: item.label.replaceAll(' ', '&nbsp;')}} />
                    </Link>
                </li> : <li className="flex items-center leading-relaxed min-w-min pr-8 opacity-50 md:opacity-60">
                    <span className="text-sm" dangerouslySetInnerHTML={{ __html: item.label.replace(' ', '&nbsp;')}} />
                </li> }
            </Fragment>))}
        </ul>
    </div>
}
